// Utility to convert AWS S3 URLs to CloudFront CDN URLs for faster streaming
const S3_BASE_URL = 'https://paulavatar.s3.us-east-2.amazonaws.com';
const CLOUDFRONT_BASE_URL = 'https://d1toilbxxou8sc.cloudfront.net';

/**
 * Converts S3 URLs to CloudFront CDN URLs for optimized streaming
 * Also removes language suffixes that were added for IndexedDB keys
 * @param {string} url - The original URL (S3 or CloudFront)
 * @returns {string} - The CloudFront CDN URL ready for streaming
 */
export function convertToCDNUrl(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }

  let processedUrl = url;

  // Remove language suffixes first (before URL conversion)
  // Pattern: filename.ext_en, filename.ext_es, etc.
  // These suffixes were used for IndexedDB lookup but the actual files don't have them
  processedUrl = processedUrl.replace(/\.(mp4|mov|avi|webm|mkv)_[a-z]{2}$/i, '.$1');

  // Convert S3 URL to CloudFront CDN URL
  if (processedUrl.includes(S3_BASE_URL)) {
    processedUrl = processedUrl.replace(S3_BASE_URL, CLOUDFRONT_BASE_URL);
  }
  // Handle alternative S3 URL formats
  else if (processedUrl.includes('s3.us-east-2.amazonaws.com/paulavatar')) {
    processedUrl = processedUrl.replace('https://s3.us-east-2.amazonaws.com/paulavatar', CLOUDFRONT_BASE_URL);
  }
  // If already CloudFront, keep it
  else if (processedUrl.includes(CLOUDFRONT_BASE_URL)) {
    // Already CloudFront, no conversion needed
  }

  return processedUrl;
}

/**
 * Batch convert multiple URLs to CloudFront CDN URLs
 * @param {Array} urls - Array of URLs (S3 or CloudFront)
 * @returns {Array} - Array of CloudFront CDN URLs
 */
export function convertMultipleToCDNUrls(urls) {
  if (!Array.isArray(urls)) {
    return urls;
  }

  return urls.map(url => convertToCDNUrl(url));
}

/**
 * Convert video list objects to use CloudFront CDN URLs
 * @param {Array} videoList - Array of video objects with url property
 * @returns {Array} - Array with CloudFront CDN URLs
 */
export function convertVideoListToCDN(videoList) {
  if (!Array.isArray(videoList)) {
    return videoList;
  }

  return videoList.map(video => ({
    ...video,
    url: convertToCDNUrl(video.url),
  }));
}
